var render = function render(){var _vm=this,_c=_vm._self._c;return _c('advertiser-selector',{on:{"selection":_vm.redirectToAdvertiser}})
}
var staticRenderFns = []

export { render, staticRenderFns }